import { processError }                                                                              from '../../../api/customFetch';
import { AccountBean, AccountControllerApi, ItemResponseAccountBeanObject, ListResponseAccountBean } from '../../../api/api';
import { BaseApi, configuration }                                                                    from '../../../api/BaseApi';
import { StorageKey }                                                                                from '../../../util/Storage';

class AccountApi extends BaseApi {
    api: AccountControllerApi;

    constructor() {
        super();
        this.api = new AccountControllerApi(configuration, configuration.basePath, this.customFetch);
    }

    list(size: number = 10, page: number = 1 ,searchValue?: number | string): Promise<ListResponseAccountBean> {
        const query: any = { size, page }

        if (searchValue !== undefined && searchValue !== null && searchValue !== '') {
            if (typeof searchValue === 'number') {
                query.id = searchValue
            } else {
                query.name = searchValue
            }
        }
        return this.api.accounts({query}).then(list => {
            return Promise.resolve(list);
        }).catch(err => {
            return processError(err);
        });
    }

    all(): Promise<ListResponseAccountBean> {
        return this.api.accounts().then(list => {
            return Promise.resolve(list);
        }).catch(err => {
            return processError(err);
        });
    }

    create(account: AccountBean): Promise<ItemResponseAccountBeanObject> {
        return this.api.createAccount(account).then(created => {
            return Promise.resolve(created);
        }).catch(err => {
            return processError(err);
        });
    }

    edit(id: number, account: AccountBean): Promise<ItemResponseAccountBeanObject> {
        return this.api.editAccount(account, id).then(updated => {
            return Promise.resolve(updated);
        }).catch(err => {
            return processError(err);
        });
    }

    view(id): Promise<ItemResponseAccountBeanObject> {
        return this.api.account(id).then(account => {
            return Promise.resolve(account);
        }).catch(err => {
            return processError(err);
        });
    }

    viewUser(): Promise<ItemResponseAccountBeanObject> {
        return this.api.accountProps().then(account => {
            return Promise.resolve(account);
        }).catch(err => {
            return processError(err);
        });
    }

    delete(id: number): Promise<ItemResponseAccountBeanObject> {
        return this.api.deleteAccount(id).then(account => {
            return Promise.resolve(account);
        }).catch(err => {
            return processError(err);
        });
    }

    login(username: string, password: string): Promise<boolean> {
        const form = 'username=' + encodeURIComponent(username) + '&password=' + encodeURIComponent(password);
        const options: RequestInit = {
            method: 'POST',
            body: form,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
             },
            credentials: 'include',  
        };
    
        return this.customFetch(configuration.basePath + '/api/login', options)
            .then(async (data) => {
                const token = await data.text();
                const expirationDate = 120 * 60 * 1000; // 2 hours
                document.cookie = `X-Access-Token=${token}; expires=${new Date(Date.now() + expirationDate).toUTCString()}; path=/`;
                localStorage.setItem(StorageKey.Authenticated, 'true');
                return Promise.resolve(true);
            })
            .catch((err) => {
                localStorage.setItem(StorageKey.ApiError, 'Incorrect Username or Password');
                return Promise.resolve(false);
            });
    }
    
    logout(): Promise<boolean> {

        const options: RequestInit = {method: 'GET'};

        return this.customFetch(configuration.basePath + '/api/logout', options).then(() => {
            localStorage.removeItem(StorageKey.Authenticated);
            localStorage.removeItem(StorageKey.TokenExpiration);
            localStorage.removeItem(StorageKey.DisabledDate);
            return Promise.resolve(true);
        }).catch(() => {
            return Promise.resolve(false);
        })
    }
}

const accountApi = new AccountApi();

export default accountApi;
